import { render, staticRenderFns } from "./veStuSemester.vue?vue&type=template&id=57ac71f6&scoped=true"
import script from "./veStuSemester.vue?vue&type=script&lang=js"
export * from "./veStuSemester.vue?vue&type=script&lang=js"
import style0 from "./veStuSemester.vue?vue&type=style&index=0&id=57ac71f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ac71f6",
  null
  
)

export default component.exports